import { removeTrailingSlash } from '../../utils/bookboost/string';
import {
    SET_WEBSITE_KEY,
    SET_CONVERSY_TOKEN,
    SET_API_URL,
    SET_PUSHER_INFO,
    SET_PM_CONFIG
} from '../../actions/bookboost/config-actions';

export const INITIAL_STATE = {
    websiteKey: null,
    conversyToken: null,
    api: null,
    pmConfig: {
        desktopLimit: 3,
        mobileLimit: 1
    }
};

export const ConfigReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_WEBSITE_KEY:
            return {
                ...state,
                websiteKey: action.websiteKey
            };

        case SET_CONVERSY_TOKEN:
            return {
                ...state,
                conversyToken: action.conversyToken
            };

        case SET_API_URL:
            return {
                ...state,
                apiUrl: removeTrailingSlash(action.apiUrl)
            };

        case SET_PUSHER_INFO:
            return {
                ...state,
                pusherInfo: action.pusherInfo
            };

        case SET_PM_CONFIG:
            return {
                ...state,
                pmConfig: {
                    ...state.pmConfig,
                    ...action.config
                }
            };

        default:
            return state;
    }
};
